// Angular
import { Injectable } from '@angular/core';
import Swal, {SweetAlertIcon} from "sweetalert2";
import {DataSelect} from "../models/data-select";
import {Dto} from "../models/dto.model";

export enum MessageType {
  Create,
  Read,
  Update,
  Delete
}

@Injectable()
export class SweetAlert {
  /**
   * Service constructor
   *
   * @param snackBar: MatSnackBar
   * @param dialog: MatDialog
   */
  constructor() {
  }



  success(msg: string | undefined) {
    return Swal.fire("Submitted", msg, "success");
  }

  error(msg: string | undefined) {
    return Swal.fire("Failed", msg, "error");
  }

  decision(type: any, name: any, text: any = '') {
    return Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${type} ${name} ${text}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${type} it!`
    })
  }

  decision2(text:string, confirmButtonText:string , denyButtonText:string) {
    return Swal.fire({
      title: 'Are you sure?',
      text: text,
      icon: 'question',
      width:'33rem',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      cancelButtonColor: '#d33',
      denyButtonText: denyButtonText,
      confirmButtonText: confirmButtonText
    })
  }

  /**
   * @param inputValue Pre-fills the box. Use it when the user is *amending*
   *   something that already exists — retyping a reason from memory is how the
   *   corrected version ends up saying something different from the original.
   */
  decisionWithInput(title:string, text:string, confirmButtonText:string, denyButtonText:string, inputPlaceholder:string = 'Enter your reason', inputValue:string = '') {
    return Swal.fire({
      title: title,
      text: text,
      input: 'text',
      inputPlaceholder: inputPlaceholder,
      inputValue: inputValue,
      icon: 'question',
      width:'33rem',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      cancelButtonColor: '#d33',
      denyButtonText: denyButtonText,
      confirmButtonText: confirmButtonText,
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter a reason'
        }
        return null
      }
    })
  }

  decision3(title:string, text:string, confirmButtonText:string="yes" , denyButtonText:string) {
    return Swal.fire({
      title: title,
      text: text,
      icon: 'question',
      width:'33rem',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      cancelButtonColor: '#d33',
      denyButtonText: denyButtonText,
      confirmButtonText: confirmButtonText
    })
  }

  decisionHtml(title:string, html:string, confirmButtonText:string , denyButtonText:string, icon:SweetAlertIcon="question") {
    return Swal.fire({
      title: title,
      html: html,
      icon: icon,
      width:'50rem',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#d33',
      cancelButtonColor: '#d33',
      denyButtonText: denyButtonText,
      confirmButtonText: confirmButtonText
    })
  }

    subscriptionWelcomeHtml(title:string, html:string, confirmButtonText:string , denyButtonText:string) {
        return Swal.fire({
            title: title,
            html: html,
            imageWidth: 200,
            imageHeight: 200,
            imageAlt: 'Welcome',
            imageUrl: './assets/media/svg/general/store_front_1.svg',
            width:'50rem',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            denyButtonColor: '#d33',
            cancelButtonColor: '#d33',
            denyButtonText: denyButtonText,
            confirmButtonText: confirmButtonText
        })
    }

  productDecision(type: any, name: any,) {
    return Swal.fire({
      title: 'Info',
      text: ` ${name}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${type} it!`
    })
  }

  notification(title: any, text: any) {
    return Swal.fire({
      position: 'top-end',
      title: title,
      text: text,
      showConfirmButton: false,
      backdrop: false,
      timer: 3000,
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `
      },
      hideClass: {
        popup: `
      animate__animated
      animate__fadeOutDown
      animate__faster
    `
      }
    })
  }


}
